import { createSlice } from '@reduxjs/toolkit';

import jwtService from 'app/services/jwtService';
import { setUserData } from 'app/auth/store/userSlice';
import { hideSplashScreen, showSplashScreen } from 'app/auth/splashScreen';

// How long the splash screen stays up after signing in, while the first page loads behind it
const SIGN_IN_SPLASH_MS = 1200;

export const submitLogin =
  ({ username, password }) =>
  async (dispatch) => {
    dispatch(loginInitiated());

    return jwtService
      .signInWithEmailAndPassword(username, password)
      .then(async (user) => {
        // Cover the log-in form before setting the user redirects to the app underneath
        await showSplashScreen();
        dispatch(setUserData(user));
        dispatch(loginSuccess());
        hideSplashScreen(SIGN_IN_SPLASH_MS);
      })
      .catch((errors) => {
        hideSplashScreen();
        dispatch(loginError(errors));
      });
  };

const initialState = {
  success: false,
  isLoading: false,
  error: '',
};

const loginSlice = createSlice({
  name: 'auth/login',
  initialState,
  reducers: {
    loginInitiated: (state) => {
      state.isLoading = true;
    },
    loginSuccess: (state, action) => {
      state.success = true;
      state.isLoading = false;
      state.error = '';
    },
    loginError: (state, action) => {
      state.success = false;
      state.isLoading = false;
      state.error = action.payload.message;
    },
  },
  extraReducers: {},
});

export const { loginSuccess, loginError, loginInitiated } = loginSlice.actions;

export default loginSlice.reducer;
